import { Button } from "@shapr3d/frontend-lib";
import classNames from "classnames";
import type { FileWithPath } from "react-dropzone";

import style from "./FileList.module.css";

interface FileListProps {
  files: FileWithPath[];
  removeFile: (filePath: string | undefined) => void;
  disabled?: boolean;
}

const FileList: React.FC<FileListProps> = ({ files, removeFile, disabled }) => (
  <ul className={style.fileNameList}>
    {files.map((file) => (
      <li key={String(file.path)} className={style.fileNameContainer}>
        <div className={classNames(style.fileName, disabled && style.disabled)}>
          {String(file.path)}
        </div>
        <Button
          disabled={disabled}
          variant="grayscale"
          className={style.fileDeleteButton}
          onClick={() => removeFile(file.path)}
        >
          Delete
        </Button>
      </li>
    ))}
  </ul>
);

export default FileList;
